// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202511051505/js/" + chunkId + "." + {"44":"431b4d90","225":"5341da42","481":"5ee00406","486":"e707bd52","770":"0f6bfe09"}[chunkId] + ".0.6849181216231419.chunk.js";
};